export enum CostLevelEnum {
  STD0 = 0,
  STD1 = 1,
  PACA2 = 2,
  PACA3 = 3,
  PACA4 = 4,
}
